<template>
  <div class="currency-badge">
    <span>{{ currency }}</span>
  </div>
</template>

<script>
export default {
  name: 'CurrencyBadge',
  props: {
    currency: {
      type: String,
      default: '€'
    }
  }
}
</script>

<style scoped lang="scss">
  .currency-badge{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
    color: map-get($green, 'alert');
    overflow: hidden;
    width: 65px;
    height: 65px;

    &::before {
      background-color: map-get($grey, 'dark');
      box-shadow: 0 3px 6px rgba(#000, .3);
      content: '';
      display: block;
      transform: rotate(45deg) translate(-5px, -27px);
      width: 85px;
      height: 60px;
    }

    span{
      position: absolute;
      top: 6px;
      right: 8px;
      font-size: 28px;
      font-weight: 400;
      line-height: 25px;
    }
  }
</style>
